import { googleMapsServiceClient as client } from '@/api/google-maps/googleMapsServiceClient';
import { StreetViewImageMetaData, StreetViewStatus } from '@/api/google-maps/types/streetView';

async function getStreetViewImageMetaData(location: string): Promise<StreetViewImageMetaData | undefined> {
  try {
    const response = await client.get<StreetViewImageMetaData>(`/streetview/metadata?location=${location}`);

    if (response.data.status !== StreetViewStatus.Ok) {
      Promise.reject(response.data.status);
    }

    return response.data;
  } catch (error) {
    Promise.reject(error);
  }
}

export default {
  getStreetViewImageMetaData
};
